import React, { useContext, useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import { AuthContext } from 'src/context/AuthContext'
import { authStorage } from 'src/utils/authStorage'

const ClientLoginStatus = () => {
  const { clientData, selectedClientId, setSelectedClientId, rememberMe } =
    useContext(AuthContext)
  const [, setOpenClientList] = useState(false)

  const handleOpenClientList = () => {
    setOpenClientList(true)
  }

  // Add this at the top of your ClientLoginStatus component
  useEffect(() => {
    // Save to localStorage whenever data changes

    // //console.log(clientData,selectedClientId)
    if (clientData) {
      authStorage.setStoredClientData('clientData', clientData, rememberMe)
    }

    if (selectedClientId) {
      authStorage.setStoredSelectedClientId('selectedClientId', selectedClientId, rememberMe)
    }
  }, [clientData, selectedClientId])

  // Add this to restore data on component mount

  useEffect(() => {
    const storedSelectedClientId = authStorage.getStoredSelectedClientId('selectedClientId')

    // if (storedClientData && !clientData) {
    //   // You'll need a setter function from context for this
    //   setClientData(JSON.parse(storedClientData));
    // }
    if (storedSelectedClientId && !selectedClientId) {
      setSelectedClientId(storedSelectedClientId)
    }
  }, [])

  //   useEffect(() => {
  //   if (clientData) {
  //     //console.log('clientData updated:', clientData)
  //   }

  // }, [clientData])

  const filteredClients = clientData?.clients?.filter(client => client.clientId === selectedClientId) || []

  if (!clientData?.clients) {
    return <Typography>No clients available</Typography>
  }

  return (
    <div>
      <Grid>
        {filteredClients.map(client => {
          return (
            <Grid item xs={12} sm={6} md={4} key={client.clientId}>
              <div
                onClick={handleOpenClientList}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '40px',
                  width: 'auto',
                  gap: '8px',
                  cursor: 'pointer'
                }}
              >
                {/* {client.image ? (
                  <img
                    src={`data:image/png;base64,${client.image}`}
                    alt={client.clientName}
                    style={{
                      width: 25,
                      height: 25,
                      borderRadius: '50%'
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: 27,
                      height: 27,
                      borderRadius: '50%',
                      backgroundColor: '#666cff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#fff'
                    }}
                  >
                    {client.clientName ? client.clientName.charAt(0).toUpperCase() : '?'}
                  </div>
                )} */}
                <Typography
                  sx={{
                    fontSize: '16px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '100px',
                    color: '#fff',
                    textTransform: 'capitalize',
                    letterSpacing: '0.7px'
                  }}
                >
                  {client.clientName}
                </Typography>
              </div>
            </Grid>
          )
        })}
      </Grid>
      {/* {isMultipleClients && (
        <LoginClientList
           openClientList={openClientList}
          handlecloseClientList={handleCloseClientList}
          clientData={clientData}
          selectedClientId={selectedClientId}
          setSelectedClientId={setSelectedClientId}
          handleLoginClient={handleLoginClient}
          tempAuthToken={tempAuthToken}
        />
      )} */}
    </div>
  )
}

// ClientLoginStatus.propTypes = {
//   clientData: PropTypes.shape({
//     clients: PropTypes.arrayOf(
//       PropTypes.shape({
//         clientId: PropTypes.string.isRequired,
//         clientName: PropTypes.string.isRequired,
//         image: PropTypes.string,
//       })
//     ).isRequired,
//   }).isRequired,
// };

export default ClientLoginStatus
